import './index.scss'
import '../../assets/scripts/jquery.paroller.js'
$("header .nav ul li").eq(4).addClass("active"); 
$('.application ul li .pic .img').paroller();
